"use client";
import {
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";

import { formatUtcDateTime } from "@/app/_utils/dayjs";

import { capitalize, truncate } from "lodash";

import CuoButton from "@/app/admin/_common/CuoButton";
import { Trash2 as DeleteIcon, Circle as CircleIcon, PlusCircle as AddCircleOutlineIcon } from "lucide-react";

interface BuzzTitleProps {
  campaign: any;
  handleClose: any;
  handleDeleteDialogOpen: any;
  onAddContent?: () => void;
}

export default function BuzzTitle(props: BuzzTitleProps) {
  const { campaign, handleDeleteDialogOpen, onAddContent } = props,
    theme = useTheme(),
    matchesBreakpoint = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      container
      justifyContent={"end"}
      alignItems={"center"}
      columnGap={1}
      width={"100%"}
    >
      <Grid container flex={1}>
        <Grid container alignItems={"center"} columnGap={1}>
          <Grid>
            <Grid container>
              <Typography
                fontSize={matchesBreakpoint ? "18px" : "23px"}
                fontWeight={"bold"}
                title={campaign?.name}
              >
                {truncate(campaign?.name, {
                  length: matchesBreakpoint ? 30 : 40,
                })}
              </Typography>
            </Grid>
            <Typography variant="body2">
              {formatUtcDateTime(campaign?.created_at, "dddd, MMM D • h:mm a z")}
            </Typography>
          </Grid>

          <Grid
            container
            alignItems={"center"}
            justifyContent={"center"}
            columnGap={0.5}
            mt={0.5}
            ml={1}
            sx={{
              height: "20px",
              width: "57px",
              background:
                campaign?.status === "draft" ? "#e9e9e990" : "#4BB54320",
              border: `1px solid ${
                campaign?.status === "draft" ? "#c9c9c9" : "#4BB543"
              }`,
              paddingRight: "4px",

              borderRadius: "100px",
            }}
          >
            <CircleIcon
              style={{ color: campaign?.status === "draft" ? "#999999" : "#4BB543", width: "10px", height: "10px" }}
            />
            <Typography
              fontSize={"11px"}
              sx={{
                color: campaign?.status === "draft" ? "grey" : "#4BB543",
              }}
            >
              {capitalize(campaign?.status)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <IconButton
        disableRipple
        size={"small"}
        color="error"
        onClick={() => handleDeleteDialogOpen()}
        sx={{
          height: "30px",
          border: "var(--mh-border-soft)",
          borderRadius: "5px",
          background: "white",
          ":hover": {
            background: "var(--mh-bg-hover)",
          },
        }}
      >
        <DeleteIcon />
      </IconButton>
      <CuoButton
        label={"Add Content"}
        icon={<AddCircleOutlineIcon />}
        onClick={() => onAddContent?.()}
      />
    </Grid>
  );
}
